<template>
  <div class="blog-pg">
<!--    <Search />-->
    <v-container v-if="article && article.page">
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs" />
      </div>
      <div class="blog-pg-body">
        <h1 class="title-pg" v-if="!article.page.hide_title">
          {{ article.page.transTitle }}
        </h1>
        <div
                class="content"
                v-if="!article.page.hide_content"
                v-html="article.page.transContent"
        ></div>
        <div class="bgw-pdg-20">
          <div class="news" v-if="article.children">
            <div
                    class="news-item"
                    v-for="child in article.children"
                    :key="child.id"
            >
              <div class="img" v-if="getImg(child.transContent)">
                <img :src="getImg(child.transContent)">
              </div>
              <div class="news-data">
                <h4>
                  <router-link
                          :to="{ name: 'article', params: { slug: child.slug } }"
                          :key="child.id"
                  >
                    {{ child.transTitle }}
                  </router-link>
                </h4>
                <div class="date">
                  {{ new Date(child.publish_date) | dateFormat('DD.MM.YYYY') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
// import Search from '@/components/Search'
import CMS from '@/model/cms'

export default {
  components: {
    // Search
  },
  data: () => ({
    article: null,
    breadcrumbs: []
  }),
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData'
  },
  mounted () {
    this.fetchData()
  },
  created () {
    this.scrollToTop()
  },
  methods: {
    fetchData () {
      CMS.loadBlogBySlug(this.$route.params.slug)
        .then((response) => {
          this.breadcrumbs = [
            {
              text: this.$i18n.t('Home'),
              disabled: false,
              href: '/'
            }
          ]
          this.article = response.data
          if (this.article) {
            var breadcrumb = {}
            breadcrumb.text = this.article.page.transTitle
            breadcrumb.disabled = true
            this.breadcrumbs.push(breadcrumb)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getImg (content) {
      const elContent = document.createElement('div')
      elContent.innerHTML = content.trim()

      const firstImage = elContent.getElementsByTagName('img')[0]

      if (firstImage) {
        return firstImage.src
      }

      return false
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.main-template {
  .v-application {
    a {
      color: #000;
      text-decoration: underline;
    }

    a:hover {
      text-decoration: none;
    }
  }
}
</style>
